import   moment       from 'moment';
import { dateFormat } from 'alto-utils/lib/utils';
import   GroupMenu    from './group_menu';

export default class MenuSummary {
  constructor(menu) {
    this.menu = menu;
  }

  static for(menu) {
    // remove course menus without selection and group menus after deadline
    // also remove all parent menus for which the filtered child menus are empty
    const canteenMenus = menu._canteenMenus
      .map((dailyMenus, canteenID) => dailyMenus
        .map((groupMenus, formattedDate) => groupMenus
          .map(courseMenus => courseMenus.filter(courseMenu => courseMenu.hasSelection()))
          .filter((courseMenus, groupName) => {
            const canteen   = menu.canteens.find(canteenID);
            const date      = moment(formattedDate, dateFormat);
            const group     = menu.groups.find(groupName);
            const groupMenu = new GroupMenu(canteen, date, group, courseMenus, menu);

            return courseMenus.size && !groupMenu.isAfterDeadline();
          })
        )
        .filter(groupMenus => groupMenus.size)
      )
      .filter(dailyMenus => dailyMenus.size);

    return new (this)(menu.with(canteenMenus));
  }

  canteenMenus() {
    return this.menu.canteenMenus();
  }
}
